import { render, staticRenderFns } from "./LoaderScreen.vue?vue&type=template&id=1012c376&scoped=true&"
import script from "./LoaderScreen.vue?vue&type=script&lang=js&"
export * from "./LoaderScreen.vue?vue&type=script&lang=js&"
import style0 from "./LoaderScreen.vue?vue&type=style&index=0&id=1012c376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1012c376",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
